import { render, staticRenderFns } from "./ComercialAvatarStore.html?vue&type=template&id=379fe197&scoped=true&external"
import script from "./ComercialAvatarStore.vue?vue&type=script&lang=js"
export * from "./ComercialAvatarStore.vue?vue&type=script&lang=js"
import style0 from "./ComercialAvatarStore.scss?vue&type=style&index=0&id=379fe197&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379fe197",
  null
  
)

export default component.exports